export const _layout = {
  full: '100%',
  '1/2': '50%',
  '1/3': '33.333%',
  '2/3': '66.666%',
  '1/6': '16.666%',
  '4/6': '66.666%',
} as const;
